import { SignupFlow } from 'corgi-types';

import { useLocalization } from '../../providers/LocaleProvider';
import { getUserFlowQueryParam } from '../../utils/signup';

const KEY_LOGIN_URL = 'h24_login_page_url';
const FORGOT_PASSWORD_URL = '/forgotpassword';
const CHECKOUT_SIGNUP_URL = `/checkout/signup${getUserFlowQueryParam(SignupFlow.Checkout)}`;
const GIFT_CARD_CHECKOUT_SIGNUP_URL = `/giftcard/checkout/signup${getUserFlowQueryParam(SignupFlow.GiftCardCheckout)}`;

export const useLoginUrl = (userFlow: SignupFlow) => {
  const { t, p } = useLocalization();

  if (userFlow === SignupFlow.Checkout) {
    return p(CHECKOUT_SIGNUP_URL);
  }

  if (userFlow === SignupFlow.GiftCardCheckout) {
    return p(GIFT_CARD_CHECKOUT_SIGNUP_URL);
  }

  return p(t(KEY_LOGIN_URL)) + getUserFlowQueryParam(userFlow);
};

export const useLoginFormUrls = (userFlow: SignupFlow) => {
  const { p } = useLocalization();
  const queryParams = getUserFlowQueryParam(userFlow);
  const loginUrl = useLoginUrl(userFlow);

  return {
    loginUrl,
    forgotPasswordUrl: String(p(FORGOT_PASSWORD_URL)) + queryParams,
  };
};
